import React, {useEffect} from 'react';
import Text from "@/Components/Front/Text";


const Consent = ({textProps}) => {

    const [hide, setHide] = React.useState(false);
    const [modal1, setModal1] = React.useState(false);
    const [modal2, setModal2] = React.useState(false);
    const cookieExists = (name) => {
        return (document.cookie.split('; ').indexOf(name + '=' + 1) !== -1);
    }

    useEffect(() => {
        if (cookieExists("laravel_cookie_consent")) {
            setHide(true);
        }
        console.log(cookieExists("laravel_cookie_consent"));

    }, [])
    return (


        <>
            {!hide &&
                <section id={"consent"}>

                    <div className="js-cookie-consent cookie-consent fixed bottom-0 inset-x-0 pb-2 z-10">
                        {modal1 ?
                            <div className="max-w-7xl mx-auto px-6">

                                <div className="p-2 rounded-lg bg-yellow-100">
                                    <div className={"consent-modal-1"}>
                                        <div className="flex items-center justify-between flex-wrap">
                                            <div className="w-0 flex-1 items-center hidden md:inline">
                                                <p className="ml-3 text-black cookie-consent__message">
                                                    <Text {...textProps} str={'cookies-text'} html={true}/>
                                                    <span className={"flex"}>


                                                <button onClick={() => {
                                                    window.laravelCookieConsent.consentWithCookies();
                                                    setModal1(false)
                                                    setHide(true)

                                                }}
                                                        className="mr-3 js-cookie-consent-agree cookie-consent__agree cursor-pointer flex items-center justify-center px-4 py-2 rounded-md text-sm font-medium text-yellow-800 bg-yellow-400 hover:bg-yellow-300">
                                                    <Text {...textProps} str={'consent-agree'}/>

                                                </button>
                                                <button onClick={() => {
                                                    setModal1(false)

                                                }}
                                                        className="js-cookie-consent-agree cookie-consent__agree cursor-pointer flex items-center justify-center px-4 py-2 rounded-md text-sm font-medium text-yellow-800 bg-yellow-400 hover:bg-yellow-300">
                                                    <Text {...textProps} str={'consent-disagree'}/>

                                                </button>
                                                </span>
                                                    <br/>
                                                    <span>
                                                        For more information, please visit the <a target="_blank"
                                                                                                  href="https://trydatatherapy.com/policy/cookies-policy.html">Cookies Policy.</a>
                                                    </span>
                                                </p>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>
                            :
                            <div className="max-w-7xl mx-auto px-6">
                                <div className="p-2 rounded-lg bg-yellow-100">
                                    <div className="flex items-center justify-between flex-wrap">
                                        <div className="w-0 flex-1 items-center hidden md:inline">
                                            <p className="ml-3 text-black cookie-consent__message">

                                                <Text {...textProps} str={'consent-message'}/>
                                            </p>
                                        </div>
                                        <div className="mt-2 flex-shrink-0 w-full sm:mt-0 sm:w-auto">
                                            <button onClick={() => {
                                                // window.laravelCookieConsent.consentWithCookies();
                                                setModal1(true);
                                            }}
                                                    className="js-cookie-consent-agree cookie-consent__agree cursor-pointer flex items-center justify-center px-4 py-2 rounded-md text-sm font-medium text-yellow-800 bg-yellow-400 hover:bg-yellow-300">
                                                <Text {...textProps} str={'consent-more'}/>

                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                </section>
            }

        </>

    )

}


export default Consent;
